import { useCallback } from 'react';

import { useSharedState } from '@trello/shared-state';

import {
  type SortKey,
  sortMap,
  workspaceBoardsFilterState,
} from './workspaceBoardsFilterState';

/**
 * Hook responsible for reading and updating the
 * workspaceBoardsFilterState shared state values
 */
export const useWorkspaceBoardsFilterState = () => {
  const [state, setState] = useSharedState(workspaceBoardsFilterState);

  const setSearchQuery = useCallback(
    (q: string) => setState({ searchQuery: q }),
    [setState],
  );

  const setTagFilter = useCallback(
    (c: string | null) => setState({ tagFilter: c }),
    [setState],
  );

  const setSortOrder = useCallback(
    (s: SortKey) =>
      setState({
        sort: s,
        sortBy: sortMap[s].sortBy,
        sortOrder: sortMap[s].sortOrder,
      }),
    [setState],
  );

  return {
    ...state,
    setSortOrder,
    setSearchQuery,
    setTagFilter,
  };
};
